
































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {MdbsIdProvider} from "@/api/tsclient";
import InstituteDto = MdbsIdProvider.InstituteDto;
import {deepCopy} from "@/auxillary";

@Component({})
export default class InstituteEditDialog extends Vue {

  @Prop({required: true})
  institute!: InstituteDto;

  instituteToEdit!: InstituteDto;

  @Watch('institute', {
    immediate: true, deep: true
  })
  onInstituteChange(institute: InstituteDto) {
    this.instituteToEdit = deepCopy(institute);
    this.$forceUpdate();
  }

  valid: boolean = false;
  rules: any = {
    required: (value: any) => !!value || 'Wird benötigt',
  }

}
